import React from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";

export default function ParentGuardian() {

    const app = ApplicantContainer.useContainer();
    
    function handleChange(evt) {

        if(evt.target.name === 'frPGConsentICPassport') 
            evt.target.value = evt.target.value.replace(/[^a-z0-9]/gi,'');
           
        app.onChangeInStdValues({...app.inStdValues, [evt.target.id]:evt.target.value});
    }

    return (
    
        app.showParentGuardian ? 
        <>        
        <Form.Row>
        <Col xs={12}>
            <Form.Group as={Col} htmlFor="frPGConsent">
                <Form.Label>PARENT/GUARDIAN (IF APPLICANT IS BELOW 18 YEARS OLD)</Form.Label>
                <Form.Text className="declaration">                
                I have read the Personal Data Protection Notice provided by Sunway University/Sunway College (Kuala Lumpur) pursuant to section 7 of Personal Data Protection Act 2010 (http://sunway.edu.my/pdpa/notice_english), which includes purposes for which my child/ ward’s personal data is collected/processed and classes of third parties to whom Sunway Universit/Sunway College (Kuala Lumpur) will/may disclose my child/ward’s personal data to.
                <br/><br/>
                I hereby give consent to Sunway University/Sunway College (Kuala Lumpur) to process my child/ward’s personal data in accordance with the Personal Data Protection Notice.
                </Form.Text>
            </Form.Group>
        </Col>
        </Form.Row>
        
        <Form.Row>
        <Col xs={12} lg={6}>
            <Form.Group as={Col} controlId="frPGConsentName" htmlFor="frPGConsentName">
                <Form.Label>Parent/ Guardian's Name</Form.Label>
                <Form.Control required type="text" placeholder="" name="frPGConsentName" value={app.inStdValues.frPGConsentName} onChange={handleChange} />
                <Form.Control.Feedback type="invalid">
                  Please enter Parent/ Guardian's Name.
                </Form.Control.Feedback>                
            </Form.Group>
        </Col>
        <Col xs={12} lg={6}>
        <Form.Group as={Col} controlId="frPGConsentICPassport" htmlFor="frPGConsentICPassport">
            <Form.Label>Parent/ Guardian's NRIC/ Passport No.</Form.Label>
            <Form.Control required type="text" placeholder="" name="frPGConsentICPassport" value={app.inStdValues.frPGConsentICPassport} onChange={handleChange} />
            <Form.Control.Feedback type="invalid">
                Please enter Parent/ Guardian's NRIC/ Passport No.
            </Form.Control.Feedback>                
        </Form.Group>
        </Col>
        </Form.Row>
      </>
        :
        <>
        </>
    );
}